export class String {

    static get empty(): string {
      return '';
    }
  
    static isNullOrWhiteSpace = function(toVerify: string): boolean {
      let isNullOrEmpty: boolean = toVerify == null ||  toVerify == undefined ||  toVerify == this.empty;
      let onlyContainWhiteSpaces: boolean = false;
  
      if (!isNullOrEmpty) {
        let whiteSpaceCharacters: number = 0;
  
        for (let index = 0; index < toVerify.length; index++) {
          if (toVerify[index] === ' ')
            whiteSpaceCharacters++;
        }
  
        onlyContainWhiteSpaces = whiteSpaceCharacters === toVerify.length;
      }
  
      return isNullOrEmpty || onlyContainWhiteSpaces;
    }
  }
  
  export {}
  